import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SettingsEnum } from 'src/app/shared/model/settings.enum';
import { FacadeService } from 'src/app/shared/service-facade/facade.service';

@Component({
  selector: 'app-fdic-img',
  templateUrl: './fdic-img.component.html',
  styleUrls: ['./fdic-img.component.scss']
})
export class FdicImgComponent implements OnInit {
  isDesktopView$: Observable<boolean>;
  isBaskBrand$: Observable<boolean>;
  fdicImgLink: string = '';
  fdicImgAltTxt: string = '';

  constructor(
    private _facade: FacadeService
  ) {
    this.isDesktopView$ = this._facade.isDesktopView$;
    this.isBaskBrand$ = this._facade.isBaskBrand$;
  }

  ngOnInit(): void {
    this.setupFdicData();
  }

  setupFdicData(): void {
    this.isDesktopView$.pipe(
      map((isDesktop: boolean) => {
        const imgLink = this._facade.getStorageItem(isDesktop ? SettingsEnum.FDICImgDesktop : SettingsEnum.FDICImgMobile) || '';
        const altTxt = this._facade.getStorageItem(SettingsEnum.FDICAltText) || '';
        return { imgLink, altTxt };
      })
    ).subscribe(({ imgLink, altTxt }) => {
      this.fdicImgLink = imgLink;
      this.fdicImgAltTxt = altTxt;
    });
  }
}
